import { render } from "./AddArticleLabelDialog.vue?vue&type=template&id=7b2e69fc&scoped=true&ts=true"
import script from "./AddArticleLabelDialog.vue?vue&type=script&lang=ts"
export * from "./AddArticleLabelDialog.vue?vue&type=script&lang=ts"

import "./AddArticleLabelDialog.vue?vue&type=style&index=0&id=7b2e69fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2e69fc"]])

export default __exports__